// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/sharing.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum ai.h2o.storage.SharingType
 */
export const SharingType = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.SharingType",
  [
    {no: 0, name: "SHARING_TYPE_UNSPECIFIED"},
    {no: 1, name: "USER_CREATED"},
    {no: 2, name: "OWNER"},
    {no: 3, name: "IMPLIED"},
  ],
);

/**
 * Represents a single sharing record for an entity.
 *
 * @generated from message ai.h2o.storage.Sharing
 */
export const Sharing = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Sharing",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "root_sharing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "restriction_role_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "type", kind: "enum", T: proto3.getEnumType(SharingType) },
    { no: 7, name: "created_time", kind: "message", T: Timestamp },
  ],
);

